import React, { memo } from 'react';
import classNames from 'classnames';

import Popup from '../../helpers/Popup';
import Button from '../../helpers/Button';
import FormGroup from '../../helpers/FormGroup';
import ErrorList from '../../helpers/ErrorList';
import { AutoSuggestion } from '../../helpers/AutoSuggestion';

import style from './style.module.css';

/**
 * Popup for flip to different team.
 *
 * @param props {Object}.
 */
const InternalFlipPopup = props => {
  const {
    module,
    dealmaker,
    associate,
    dealmakerWarning,
    associateWarning,
    suggestions,
    errors,
    waiting,
    onInputChange,
    onSuggestionClose,
    onSuggestionSelect,
    onSave,
    onClose,
  } = props;
  const modValue = module.get('value');
  const modMode = module.get('mode');
  const assoValue = associate.get('value');
  const assoMode = associate.get('mode');
  const dealmakerValue = dealmaker.get('value');
  const dealmakerMode = dealmaker.get('mode');
  const header = 'Internal Flip';
  const footer = [
    waiting ? (
      <Button key="save" className="btn-primary" data-dismiss="modal" loading>
        Save
      </Button>
    ) : (
      <Button key="save" className="btn-primary" data-dismiss="modal" onClick={onSave}>
        Save
      </Button>
    ),
    <Button key="close" data-dismiss="modal" onClick={onClose}>
      Close
    </Button>,
  ];

  return (
    <Popup footer={footer} header={header} id="accessWarning">
      <p>Flip the selected companies to the following team:</p>
      <div className="row">
        <FormGroup className="col-sm-4">
          <label className="field-label" htmlFor="moduleInput">
            Module
          </label>
          <AutoSuggestion
            className="form-control"
            id="moduleInput"
            mode={modMode}
            name="module"
            onSuggestionClose={onSuggestionClose}
            onSuggestionSelect={onSuggestionSelect}
            onTextChange={onInputChange}
            suggestions={suggestions}
            value={modValue}
            autoFocus
          />
        </FormGroup>
        <FormGroup className="col-sm-4">
          <label className="field-label" htmlFor="associateInput">
            Dealmaker 1
          </label>
          <AutoSuggestion
            className="form-control"
            id="associateInput"
            mode={assoMode}
            name="associate"
            onSuggestionClose={onSuggestionClose}
            onSuggestionSelect={onSuggestionSelect}
            onTextChange={onInputChange}
            suggestions={suggestions}
            value={assoValue}
          />
        </FormGroup>
        <FormGroup className="col-sm-4">
          <label className="field-label" htmlFor="dealmakerInput">
            Dealmaker 2
          </label>
          <AutoSuggestion
            className="form-control"
            id="dealmakerInput"
            mode={dealmakerMode}
            name="dealmaker"
            onSuggestionClose={onSuggestionClose}
            onSuggestionSelect={onSuggestionSelect}
            onTextChange={onInputChange}
            suggestions={suggestions}
            value={dealmakerValue}
          />
        </FormGroup>
      </div>
      {associateWarning ? (
        <div className={classNames(style.warning, 'alert alert-danger')} role="alert">
          {associateWarning}
        </div>
      ) : null}
      {dealmakerWarning ? (
        <div className={classNames(style.warning, 'alert alert-danger')} role="alert">
          {dealmakerWarning}
        </div>
      ) : null}
      <ErrorList className="text-danger" errors={errors} />
    </Popup>
  );
};

export default memo(InternalFlipPopup);
